import { css } from '@emotion/react';

export default $ => css`
  .entity-editor-container {
    height: 100%;
    display: flex;
    flex-direction: column;

    .entity-editor-content {
      min-height: 200px;
      overflow: auto;
      position: relative;
    }
  }

  .entity-editor .editor-section > h3 {
    color: ${$.primaryTextMain};
    background-color: ${$.primaryMain};
    padding: 0.5rem !important;
  }

  .entity-editor .editor-section > .row {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;

    .fa-chevron-right {
      transition: transform 250ms ease-in-out;

      &.rotate-90-clockwise {
        transform: rotate(90deg);
      }
    }
  }

  .entity-editor .editor-section > .row > *:last-child {
    padding-right: 3rem !important;
  }

  .entity-editor .editor-section > .row > * > label {
    font-size: 1.25rem;
    font-weight: 500;
    line-height: 1.2;
    margin-bottom: 8px;
  }

  .entity-editor .editor-section .schema-element-palette {
    .schema-element {
      background-color: #eeeeee;
      border-color: white;
      color: black;
      justify-content: center;
      align-items: center;
    }
  }

  .cursor-move {
    cursor: grab;
  }

  .cursor-moving {
    cursor: grabbing;
  }

  .entity-editor .editor-section .metadata-controls {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;

    .test-metadata-section {
      display: flex;
      align-items: center;
      gap: 0.3rem;

      > strong {
        font-weight: 500;
        white-space: nowrap;
      }

      > .form-control {
        width: 150px;
      }
    }
  }

  .entity-editor .editor-section .schema-node {
    &:hover {
      background-color: #f5f5f5;
    }
  }

  .entity-editor .editor-section .schema-node-item {
    .schema-node-item-input {
      justify-content: space-between;
      flex-grow: 1;

      > .d-flex {
        flex-grow: 1;

        input.form-control {
          max-width: 350px;
        }
      }
    }

    button.btn-clear.text-danger {
      margin-left: 0.25rem;
      white-space: nowrap;
      visibility: hidden;
    }

    &:hover {
      button.btn-clear.text-danger {
        visibility: visible;
      }
    }
  }

  .entity-editor .editor-section .metadata-row {
    > .d-flex {
      justify-content: space-between;
      align-items: center;
    }

    .metadata-key-input {
      flex-basis: 55%;
    }

    button.btn-clear.text-danger {
      visibility: hidden;
    }

    &:nth-of-type(even) {
      background-color: #f5f5f5;
    }

    &:hover {
      background-color: #dedede;
      button.btn-clear.text-danger {
        visibility: visible;
      }
    }

    .metadata-test-result {
      display: flex;
      justify-content: center;
      gap: 8px;
      padding-top: 20px;
    }
  }

  .drop-target {
    background: #f5f5f5;
    border: 1px dashed #dedede;
    border-radius: 15px;
    padding: 2rem;
  }

  @media (max-width: 850px) {
    .entity-editor .editor-section .schema-node {
      .schema-node-item {
        button.btn-danger span {
          display: none;
        }
      }
    }
    .entity-editor .editor-section .metadata-row .metadata-key-input {
      flex-basis: 70%;
    }
  }

  @media (max-width: 768px) {
    .entity-editor .editor-section .schema-node {
      .schema-node-item {
        button.btn-danger span {
          display: none;
        }
      }
    }

    .entity-editor .editor-section .metadata-row .metadata-key-input {
      flex-basis: 100%;
    }
  }
`;
